<template>
  <div class="video-wrapper w-100p h-100p p-r">
    <video
      :loop="videoInfo.isAnimation ? true : false"
      :autoplay="videoInfo.isAnimation ? true : false"
      :controls="videoInfo.isAnimation ? false : true"
      :poster="videoInfo.poster"
      :src="videoSrc"
      width="100%"
      height="100%"
      muted
      x5-playsinline
      x5-video-player-type="h5"
      x-webkit-airplay="allow"
      playsinline
      webkit-playsinline
      preload="none"
      ref="singleVideo"
    ></video>
    <i class="video-alpha-mask d-b p-a t-0 l-0 w-100p h-100p z-1" v-show="!isPlaying"></i>
    <span class="video-play-btn-icon d-f ai-c p-a c-p z-3" @click="playVideo" v-show="!isPlaying"></span>
  </div>
</template>

<script>
  // import { gsap } from 'gsap'
  import { ScrollTrigger } from 'gsap/dist/ScrollTrigger.js'

  export default {
    props: {
      videoInfo: {
        required: true,
        default: () => {}
      }
    },
    data() {
      return {
        isPlaying: false,
        videoSrc: ''
      }
    },
    mounted() {
      this.checkVideoState()
      this.loadVideoPlay()
    },
    methods: {
      playVideo() {
        const currentVideo = this.$refs.singleVideo
        currentVideo.play()
      },
      loadVideoPlay() {
        const currentVideo = this.$refs.singleVideo
        ScrollTrigger.create({
          trigger: currentVideo,
          // markers: true,
          start: 'top-=200 bottom',
          end: 'bottom',
          onEnter: () => {
            this.videoSrc = this.videoInfo.dataSrc
            if (this.videoInfo.isAnimation) {
              currentVideo.play()
            }
          },
          onEnterBack: () => {
            this.videoSrc = this.videoInfo.dataSrc
            if (this.videoInfo.isAnimation) {
              currentVideo.play()
            }
          },
          onLeave: () => {
            currentVideo.pause()
          },
          onLeaveBack: () => {
            currentVideo.pause()
          }
        })
      },
      checkVideoState() {
        const currentVideo = this.$refs.singleVideo
        currentVideo.addEventListener('playing', () => {
          this.isPlaying = true
        })
        currentVideo.addEventListener('pause', () => {
          this.isPlaying = false
        })
        currentVideo.addEventListener('ended', () => {
          this.isPlaying = false
        })
        currentVideo.addEventListener('timeupdate', () => {})
      }
    }
  }
</script>

<style lang="scss" scoped>
  .video-wrapper {
    .video-play-btn-icon {
      width: 0.56rem;
      height: 0.56rem;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      transform-origin: 50% 50%;
      transition: transform 0.3s linear;
      background: transparent;
      border: 1px solid #fff;
      border-radius: 50%;
      &:hover {
        transform: translate(-50%, -50%) scale(1.1);
        background: rgba(255, 255, 255, 0.3);
      }
      &:after {
        content: '';
        position: absolute;
        left: 0.17rem;
        display: block;
        width: 0.24rem;
        height: 0.24rem;
        background: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTVweCIgaGVpZ2h0PSIxOHB4IiB2aWV3Qm94PSIwIDAgMTUgMTgiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+5LiJ6KeS5b2i5aSH5Lu9PC90aXRsZT4KICAgIDxnIGlkPSLpobXpnaItMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IjktYnV0dG9uIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjk4LjAwMDAwMCwgLTI1MDMuMDAwMDAwKSIgZmlsbD0iI0ZGRkZGRiIgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgPHBhdGggZD0iTTMwNS4wMTA1NzQsMjUwNS4yNjcxNSBMMjk3LjA3ODAzOCwyNTE4LjE5MDIyIEMyOTYuODU3NjkzLDI1MTguNTQ5MTkgMjk3LjEzMDE1OSwyNTE5IDI5Ny41Njc0NjMsMjUxOSBMMzEzLjQzMjUzNywyNTE5IEMzMTMuODY5ODQxLDI1MTkgMzE0LjE0MjMwNywyNTE4LjU0OTE5IDMxMy45MjE5NjIsMjUxOC4xOTAyMiBMMzA1Ljk4OTQyNiwyNTA1LjI2NzE1IEMzMDUuNzcwNzgzLDI1MDQuOTEwOTUgMzA1LjIyOTIxNywyNTA0LjkxMDk1IDMwNS4wMTA1NzQsMjUwNS4yNjcxNSBaIE0zMDUuNSwyNTA2LjYwNTY5IEwzMTIuNDQ2NjM2LDI1MTcuOTIzMDggTDI5OC41NTIyMzEsMjUxNy45MjMwOCBMMzA1LjUsMjUwNi42MDU2OSBaIiBpZD0i5LiJ6KeS5b2i5aSH5Lu9IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzMDUuNTAwMDAwLCAyNTEyLjAwMDAwMCkgcm90YXRlKC0yNzAuMDAwMDAwKSB0cmFuc2xhdGUoLTMwNS41MDAwMDAsIC0yNTEyLjAwMDAwMCkgIj48L3BhdGg+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=')
          no-repeat center / contain;
      }
    }
    .video-alpha-mask {
      background-color: rgba(0, 0, 0, 0.5);
    }
  }
</style>
